import styled from 'styled-components';


export const StyledRow = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 62.5vh;
    margin-bottom: 10em;
    margin-top: 5em;

    div.progress-wrap {
        width: 70%;
        max-width: 600px;
    }

    h2, h2.onboarding-user {
        text-align: center;
        margin: .5em 0 .5em 0;
        font: normal bold 28px "Roboto Condensed";
    }
    h1, h1.onboarding-greeting {
        font: bold italic 36px "Roboto Condensed";
        text-align: center;
        text-transform: uppercase;
        color: #acff24;
    }

`

export const ContentWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 160px);
    grid-auto-rows: 200px;
    grid-column-gap: 2em;
    grid-row-gap: 3em;
    align-items: center;
    justify-content: center;
    background-color: #1a1a1a;
    padding: 3em 3em; 
    border-radius: 5px;
`

export const IconWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    div.icon-wrap {
        width: 160px;
        height: 160px;
        border-radius: 50%;
        background-color: #2a2a2a;
        padding: 20px;
        margin-bottom: 1em;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        transition: transform 1s ease;

        :hover {background-color: #3ee9f750; transform: scale(1.125);}

        img {max-width: 100px;}
    }

    p.icon-description {color: #fff; text-align: center; font: normal bold 13px 'Roboto'; }
`


// WEBPACK FOOTER //
// ./src/pages/Onboard/UserEngagement/UserEngagement.styles.ts